import React, { Component } from 'react';
import { Container } from './style';
import SharePoster from '../SharePoster';
import Toast from '../../common/toast';
import Loading from '../../common/loading';
import Search from '../../Mall/search'
import PromotionSearch from '../../Mall/promotionSearch'
import MechanismSearch from '../../Mall/MechanismSearch'
import FollowService from '../../../services/FollowService';
import InfoService from '../../../services/InfoService';
import AssetInstitutionService from '../../../services/AssetInstitutionService';
import NoticeService from '../../../services/NoticeService';
import { DEFAULT_ERROR_MSG, NOT_LOGIN_MSG } from '../../../utils/config';
import unit_institution from '../../../store/asset_institution/unit_institution';
import unit_institution_promotion from '../../../store/asset_institution/unit_institution_promotion';
import { isJdapp, toLoginPage, jdAppShare, isIOS, BUSINESS_INFO, HAIGUANANDZF_INFO, ASSETTYPE_INFO, getApiTypeByGetItem, webviewRedirect, MpingClick, getBusinessTypeByMP, getUrlParms, isJdjrApp, jdFinanceAppShare, universalAppShare } from '../../../utils/tool';
import Xheader from '@jmfe/jm-xheader';
import { secondShasreInWX } from '../../../utils/share'
import { createPortal } from 'react-dom';
import Dialog from '../Modal';
import { isJDAppLogin, registerCode, isHarmony, callSharePane } from '@jmfe/jd-jssdk';
import { observeDuoNavigationRecovery } from '../../../utils/duoNavigationRecovery';
const followType = 3; // 3是关注店铺
const isInJd = isJdapp(); // 是否在京东app中
const isInJdjr = isJdjrApp(); // 是否在京东金融app中
const defaultLogoUrl = 'https://img12.360buyimg.com/imagetools/jfs/t1/204781/35/15077/14329/618e0c97E0cdfea26/946b528926959aa7.png';
const pcDefaultLogoUrl = 'https://m.360buyimg.com/img/jfs/t1/27406/25/16680/8095/62a0680eE517ab4d3/b417bfc09b757c35.png';
const hgDefaultLogoUrl = 'https://m.360buyimg.com/img/jfs/t1/27406/25/16680/8095/62a0680eE517ab4d3/b417bfc09b757c35.png';
const sfDefaultLogoUrl = 'https://img11.360buyimg.com/imagetools/jfs/t1/123760/4/5977/12721/5efaa29fE863ec3f5/a6909aef81c3c2d4.png';
class TopHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendorName: '',
      logoUrlSquare: '',
      itemCount: 0, //上拍件数
      tuijieCount: 0, //推介数
      chuzhiNoticeCount: 0, //处置公告数
      orgTypeName: '',
      products: [],
      isFollowed: false,
      isLoadingShow: false,
      isDefaultLogo: false,
      noticeNum: 0, //公告数
      businessTxt:'', //业务线名称 打标用
      publishSource:'',
      mechanismSelectionNum: 0, //机构选聘数
      license: {
        have: false,
        show: false,
        value: "",
        logo: "",
        link: "",
        businessQualificationMaterialList: []
      },
      businessQualificationMaterialListModal: false, // 拍卖行商家的弹窗展示形式
      businessQualificationMaterialImageListModal: false // 拍卖行商家的经营资质图片弹窗
    }

    this.sharePoster = React.createRef();
  }

  componentDidMount(){
    
    const {vendorId} = this.props
      this.getVendorInfo(vendorId)
      this.getIsFollowed(vendorId)

      // 使用jssdk的webview能力需要先注册code
    registerCode('bdc50a7f-4b0d-4c6e-9c43-5b931576b6c9');
    this.stopDuoNavigationRecovery = observeDuoNavigationRecovery();
  }

  componentWillUnmount() {
    if (this.stopDuoNavigationRecovery) this.stopDuoNavigationRecovery();
  }

  //获取不同业务线店铺默认logo
  getDefaultLogoUrl=(publishSource)=>{
    let defaultLogo = defaultLogoUrl
    if(publishSource==BUSINESS_INFO.SIFA.code){
      defaultLogo = sfDefaultLogoUrl
    }else if(publishSource==BUSINESS_INFO.POCHAN.code){
      defaultLogo = pcDefaultLogoUrl
    }else if(publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
      defaultLogo = hgDefaultLogoUrl
    }
    return defaultLogo
  }

  // 获取店铺信息
  getVendorInfo(vendorId) {
    const publishSourceByUrl = getUrlParms("publishSource") || ""
    const orgIdType = getUrlParms("orgIdType") || ""
    InfoService.getShopOrganizationInfo(vendorId, publishSourceByUrl, orgIdType).then(res => {
      const {
        orgTypeName,
        products,
        shopName,
        logoUrlSquare,
        publishSource,
        customsStates,
        idType, //1 vendorId , 2 customs,
        dynamicSuccess,
        dynamicValue,
        // shopId,
        businessQualificationMaterialList,
        assetType,
        mShopLicenceUrl
      } = res.data
      this.setState({
        shopName,
        logoUrlSquare: logoUrlSquare && logoUrlSquare.length ? logoUrlSquare : this.getDefaultLogoUrl(publishSource),
        orgTypeName,
        products,
        isDefaultLogo: !(logoUrlSquare && logoUrlSquare.length),
        publishSource,
        customsStates,
        idType,
        license: {
          have: dynamicSuccess && dynamicValue === "DEFALUT_VALUE_NULL",
          show: dynamicSuccess && dynamicValue === "DEFALUT_VALUE_NULL",
          value: dynamicValue,
          logo: "https://img12.360buyimg.com/imagetools/jfs/t1/109375/32/44116/4795/64ec0451F06606531/0dcf95e8b062dae8.png",
          link: mShopLicenceUrl,// shopId ? `https://shopjump.m.jd.com/shopdetail/captcha?shopId=${shopId}` : "",
          businessQualificationMaterialList: businessQualificationMaterialList || []
        }
      }, () => {
        document.title = `${shopName}`
        unit_institution.customsStates = customsStates;
        unit_institution.publishSource = publishSource;
        unit_institution.apiType = getApiTypeByGetItem(publishSource);
        this.setShareInfo()
        this.getBusinessTxt(publishSource, customsStates, assetType);
        this.getItemCount(vendorId, publishSource, idType)
        if(BUSINESS_INFO.ZICHAN.code==publishSource || BUSINESS_INFO.POCHAN.code==publishSource || BUSINESS_INFO.HAIGUANANDZF.code==publishSource ){
          this.getTuijieCount(publishSource)
        }
        if(BUSINESS_INFO.HAIGUANANDZF.code==publishSource || BUSINESS_INFO.SIFA.code==publishSource || BUSINESS_INFO.ZICHAN.code==publishSource){
          if(BUSINESS_INFO.HAIGUANANDZF.code==publishSource){
            if(idType==1){
              this.getNoticeNum(vendorId, publishSource)
            }else{
              this.getNoticeNumByCustomsFunc(vendorId)
            }
          }else{
            this.getNoticeNum(vendorId, publishSource)
          }
        }
        if(BUSINESS_INFO.POCHAN.code==publishSource){
          this.getMechanismSelectionNum(vendorId)
        }
        if (publishSource === BUSINESS_INFO.ZICHAN.code) {
          this.getChuzhiNoticeCount(vendorId)
        }
      })
    }).catch(err => {
      console.log(err)
    })
  }

  // 获取标的数
  getItemCount (vendorId, publishSource, idType) {
    if(!vendorId || !publishSource){
      return
    }

    const auctionParams = unit_institution.getSellectionParams();
    auctionParams.page = 1;
    auctionParams.pageSize = 1;
    auctionParams.collapseSrcPaimaiId = '';
    auctionParams.idType = idType;
  
    AssetInstitutionService.getTargetAuctionList(auctionParams).then(res => {
      if (res && res.totalItem) {
        this.setState({
          itemCount: res.totalItem
        })
      }
    }).catch(err => {
      console.log(err)
    })
  }

  // 获取推介数
  getTuijieCount(publishSource) {
    const {
      showTuijieTab,
      vendorId
    } = this.props;

    if (unit_institution.publishSource === BUSINESS_INFO.ZICHAN.code) {
      unit_institution_promotion.auctionType = 4
      unit_institution_promotion.shopDisplay = 1
    } else if (unit_institution.publishSource === BUSINESS_INFO.HAIGUANANDZF.code) {
      unit_institution_promotion.auctionType = 2
      unit_institution_promotion.belongOrgDisplay = 1
    } else if (unit_institution.publishSource === BUSINESS_INFO.POCHAN.code) {
      unit_institution_promotion.auctionType = 5
    }

    const promotionParams = unit_institution_promotion.getSelectionParams();
    
    promotionParams.page = 1;
    promotionParams.pageSize = 4;
    if(publishSource==BUSINESS_INFO.ZICHAN.code){
      promotionParams.shopDisplay=1 // 是否在店铺页展示
    }
    if (publishSource==BUSINESS_INFO.HAIGUANANDZF.code) {
      promotionParams.belongOrgDisplay = 1
    }

    AssetInstitutionService.getPromotionAuctionList(promotionParams).then(res => {
      if (res && res.data && res.data.totalCount) {
        this.setState({
          tuijieCount: res.data.totalCount,
        })
        //分享海报如果拍品图片不够4个，用推介图片补齐
        let {products} = this.state
        const data = res.data.data
        if(products.length<4){
          const tuijieShareList = data.filter(item => !!item.mainImgUrl).slice(0, 4-products.length)
          let _products = []
          for(let i=0;i<tuijieShareList.length;i++){
            _products.push({
              productImage: tuijieShareList[i].mainImgUrl
            })
          }
          products = products.concat(_products)
          this.setState({
            products
          })
          if (products.length < 4) {
            if(BUSINESS_INFO.POCHAN.code==publishSource){
              AssetInstitutionService.getMechanismSelectionList({
                venderId: vendorId,
                pageNo:1,
                pageSize:4
              }
            ).then(res => {
              if(res && res.data && res.data.data){
                const jigouShareList = res.data.data.filter(item => !!item.mainImgUrl).slice(0, 4-products.length)
                let _jigouproducts = []
                for(let i=0;i<jigouShareList.length;i++){
                  _jigouproducts.push({
                    productImage: jigouShareList[i].mainImgUrl
                  })
                }
                products = products.concat(_jigouproducts)
                this.setState({
                  products
                })
              }
            })
            }
          }
        }
        showTuijieTab && showTuijieTab();
      }else {
        let {products} = this.state
        if (products.length < 4) {
          if(BUSINESS_INFO.POCHAN.code==publishSource){
            AssetInstitutionService.getMechanismSelectionList({
              venderId: vendorId,
              pageNo:1,
              pageSize:4
            }
          ).then(res => {
              if(res && res.data && res.data.data){
                const jigouShareList = res.data.data.filter(item => !!item.mainImgUrl).slice(0, 4-products.length)
                let _jigouproducts = []
                for(let i=0;i<jigouShareList.length;i++){
                  _jigouproducts.push({
                    productImage: jigouShareList[i].mainImgUrl
                  })
                }
                products = products.concat(_jigouproducts)
                this.setState({
                  products
                })
              }
            })
          }
        }
      }

    }).catch(err => {
      console.log(err)
    })
  }

  // 获取处置公告数
  getChuzhiNoticeCount(vendorId) {
    const {
      showChuZhiNoticeTab
    } = this.props
    NoticeService.getChuzhiNoticeList({
      venderId: vendorId, pageNo: 1, pageSize: 1
    }).then(res => {
      const chuzhiNoticeCount = res && res.totalItem ? res.totalItem : 0
      this.setState({
        chuzhiNoticeCount
      })
      if (chuzhiNoticeCount > 0) {
        showChuZhiNoticeTab && showChuZhiNoticeTab();
      }
    }).catch(err => {
      console.log('getChuZhiNoticeList error:', err)
    })
  }

  getAuctionTypeByGetTuijie=(publishSource)=>{
    let auctionType = 4
    if(publishSource==BUSINESS_INFO.POCHAN.code){
      auctionType = 5
    }
    return auctionType
  }

  // 获取公告数(vendorId 使用)
  getNoticeNum(vendorId, publishSource){
    if(!vendorId || !publishSource){
      return
    }
    InfoService.getNoticeNum({
        vendorId,
        pageNo:1,
        pageSize:1,
        publishSource
      }
    ).then(res => {
      if(res && res.totalItem){
        this.setState({
          noticeNum: res.totalItem
        })
      }
    })
  }

  //获取公告数(customs 使用)
  getNoticeNumByCustomsFunc(vendorId){
    if(!vendorId){
      return
    }
    InfoService.getNoticeNumByCustoms({customs:vendorId}).then(res => {
      if(res && res.data && res.data.noticeCount){
        this.setState({
          noticeNum: res.data.noticeCount
        })
      }
    })
  }

  // 获取机构选聘数
  getMechanismSelectionNum(venderId){
    if(!venderId){
      return
    }
    AssetInstitutionService.getMechanismSelectionList({
        venderId,
        pageNo:1,
        pageSize:1
      }
    ).then(res => {
      if(res && res.data && res.data.totalCount){
        this.setState({
          mechanismSelectionNum: res.data.totalCount
        })
      }
    })
  }

  //获取对公业务线名称
  getBusinessTxt = (publishSource, customsStates, assetType) => {
    if (publishSource) {
      let businessTxt = "";
      if (publishSource === BUSINESS_INFO.SIFA.code) {
        businessTxt = BUSINESS_INFO.SIFA.title;
      } else if (publishSource !== BUSINESS_INFO.POCHAN.code) {
        // 破产业务不展示标签（因为重整与清算不是完全准确覆盖所有商家，from tangjiaxu）
        for (var i in ASSETTYPE_INFO) {
          if (ASSETTYPE_INFO[i] && assetType === ASSETTYPE_INFO[i].code) {
            businessTxt = ASSETTYPE_INFO[i].title;
          }
        }
      }
      this.setState({
        businessTxt,
      });
    }
  };

  //获取类目名称
  getShopNewestCategory=()=>{
    const {vendorId,publishSource} = this.props
    InfoService.getShopNewestCategory({vendorId,publishSource}).then(res=>{
      if(res && res.data && res.data.length>0){
        this.setState({
          shopNewestCategory: res.data.filter(item => !!item)
        })
      }
    })
  }

  getIsFollowed(vendorId) {
    FollowService.isFollow(vendorId, followType).then(isFollowed => {
      this.setState({
        isFollowed
      })
    }).catch(err => {
      console.log(err)
    })
  }

  followClickHandle() {
    MpingClick("Auction_CollectInstitution",JSON.stringify({business_type:getBusinessTypeByMP()}))
    const {
      isFollowed
    } = this.state
    if (isFollowed) {
      this.unFollow()
    } else {
      this.follow()
    }
  }

  follow() {
    const {
      vendorId
    } = this.props
    FollowService.follow(vendorId, followType).then(data => {
      if (data) {
        Toast.success({
          message: '关注成功',
          content: '可以到“我的关注”查看哦～',
          duration: 2500
        })
        this.setState({
          isFollowed: true
        })
      } else {
        Toast.fail({
          message: DEFAULT_ERROR_MSG,
          duration: 2500
        })
      }
    }).catch(err => {
      console.log(err)
      if (err && err.message === NOT_LOGIN_MSG) {
        toLoginPage()
      } else {
        Toast.fail({
          message: DEFAULT_ERROR_MSG,
          duration: 2500
        })
      }
    })
  }

  unFollow() {
    const {
      vendorId
    } = this.props
    FollowService.unFollow(vendorId, followType).then(data => {
      if (data) {
        Toast.show({
          message: '已取消关注',
          duration: 2500
        })
        this.setState({
          isFollowed: false
        })
      } else {
        Toast.fail({
          message: DEFAULT_ERROR_MSG,
          duration: 2500
        })
      }
    }).catch(err => {
      console.log(err)
      if (err && err.message === NOT_LOGIN_MSG) {
        toLoginPage()
      } else {
        Toast.fail({
          message: DEFAULT_ERROR_MSG,
          duration: 2500
        })
      }
    })
  }


  sharePosterClickHandle() {

    // 金融App内分享
    if (isJdjrApp()) { 
      const {
        vendorId
      } = this.props
      const {
        shopName,
        logoUrlSquare,
      } = this.state;
      const shasreTitle = `京东资产交易-${shopName}`
      const shasreContent = '万千好货等你来拍'
      const shasreImgUrl = (logoUrlSquare.startsWith('http') ? logoUrlSquare : `https:${logoUrlSquare}`).replace("http://", "https://");
      const publishSourceByUrl = getUrlParms("publishSource") || ""
      const announcementByUrl = getUrlParms("announcement") || ""
      const agencyByUrl = getUrlParms("agency") || ""
      const orgIdType = getUrlParms("orgIdType") || ""
      const shasreUrl = `${window.location.origin}/#/mall/${vendorId}?agencyByUrl=${agencyByUrl}&announcementByUrl=${announcementByUrl}&publishSource=${publishSourceByUrl}&orgIdType=${orgIdType}`

      console.log('金融App内分享', {shasreTitle, shasreContent, shasreImgUrl, shasreUrl});

      // 调用金融App原生分享面板
      jdFinanceAppShare({
        title: shasreTitle,
        content: shasreContent,
        url: shasreUrl,
        imageUrl: shasreImgUrl,
        callback: (result) => {
          if (result.success) {
            console.log('金融App分享成功:', result);
            Toast.success({
              message: '分享成功',
              duration: 2000
            });
          } else {
            console.error('金融App分享失败:', result);
            Toast.fail({
              message: result.message || '分享失败',
              duration: 2000
            });
          }
        }
      });
      return
    } 

    isJDAppLogin().then(({ status, data, msg }) => {
      if (data !== '1') {
        Toast.show({
          message: '您未登录，请先登录再分享',
          duration: 2000
        })
        setTimeout(() => {
          toLoginPage()
        }, 1500)
        return
      }
      if (this.sharePoster && this.sharePoster.current && typeof this.sharePoster.current.sharePosterImage === 'function') {
        if (isHarmony()) { //鸿蒙
          const {
            vendorId
          } = this.props
          const {
            shopName,
            logoUrlSquare,
          } = this.state;
          const shasreTitle = `京东资产交易-${shopName}`
          const shasreContent = '万千好货等你来拍'
          const shasreImgUrl = logoUrlSquare.startsWith('http') ? logoUrlSquare : `https:${logoUrlSquare}`
          const publishSourceByUrl = getUrlParms("publishSource") || ""
          const announcementByUrl = getUrlParms("announcement") || ""
          const agencyByUrl = getUrlParms("agency") || ""
          const orgIdType = getUrlParms("orgIdType") || ""
          const shasreUrl = `${window.location.origin}/#/mall/${vendorId}?agencyByUrl=${agencyByUrl}&announcementByUrl=${announcementByUrl}&publishSource=${publishSourceByUrl}&orgIdType=${orgIdType}`
          callSharePane({
            title: shasreTitle,
            content: shasreContent,
            url: shasreUrl,
            img: shasreImgUrl
          })
        } else { //安卓或Ios
          this.setState({
            isLoadingShow: true
          })
          this.sharePoster.current.sharePosterImage()
        }
      }
      MpingClick("Auction_ShareInstitution",JSON.stringify({business_type:getBusinessTypeByMP()}))
    })
    
  }

  onSharePosterComplete() {
    this.setState({
      isLoadingShow: false
    })
    if (isInJd && isIOS) {
      // ios bug，使用html2canvas会发送about:blank的请求，ios没兼容，会使沉浸式失效，需要重新调一次
      // 页面效果是沉浸式先失效，页面被顶下来，等loading结束后再设置沉浸式，页面回到顶部（产品确认过交互，暂时采用该方式）
      Xheader({
        supportTran: '1',
      })
    }
  }

  setShareInfo() {
    const {
      vendorId
    } = this.props
    const {
      shopName,
      logoUrlSquare,
    } = this.state;
    const shasreTitle = `京东资产交易-${shopName}`
    const shasreContent = '万千好货等你来拍'
    const shasreImgUrl = logoUrlSquare.startsWith('http') ? logoUrlSquare : `https:${logoUrlSquare}`
    const publishSourceByUrl = getUrlParms("publishSource") || ""
    const announcementByUrl = getUrlParms("announcement") || ""
    const agencyByUrl = getUrlParms("agency") || ""
    const orgIdType = getUrlParms("orgIdType") || ""
    const shasreUrl = `${window.location.origin}/#/mall/${vendorId}?agencyByUrl=${agencyByUrl}&announcementByUrl=${announcementByUrl}&publishSource=${publishSourceByUrl}&orgIdType=${orgIdType}`
    
    // 金融App分享信息设置
    if (isJdjrApp()) {
      // 金融App环境下，分享信息已在点击事件中处理，这里只做标记
      console.log('金融App环境，分享信息将在用户点击时处理');
    } else if (isInJd) {
      this.getShopNewestCategory()
      jdAppShare({
        title: shasreTitle,
        img: shasreImgUrl,
        content: shasreContent,
        url: shasreUrl
      })
    }
    secondShasreInWX(shasreTitle,shasreContent,shasreImgUrl)
  }

  //查看公告
  gotoNotice=()=>{
    const { publishSource } = this.state
    const { vendorId } = this.props
    MpingClick("Auction_NoticeMore",JSON.stringify({business_type:getBusinessTypeByMP()}))
    let url = ''
    if(publishSource==BUSINESS_INFO.SIFA.code || publishSource==BUSINESS_INFO.POCHAN.code){
      url = `//mauction.jd.com/courtNoticeList.html?vendorId=${vendorId}&publishSource=${publishSource}`
    }else if (publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
      url = `//hgjg.m.jd.com/#/noticeList/${vendorId}`
    }
    url && webviewRedirect(url)
  }

  handleBusinessQualificationMaterialListModal = (value) => {
    this.setState({
      businessQualificationMaterialListModal: value
    }, () => {
      // 解决弹窗滚动bug
      if(document.querySelector('.dialog-container') && value) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    })
  }
  handleBusinessQualificationMaterialImageListModal = (value) => {
    this.setState({
      businessQualificationMaterialListModal: false,
      businessQualificationMaterialImageListModal: value
    }, () => {
      // 解决弹窗滚动bug
      if(document.querySelector('.dialog-container') && value) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    })
  }
  renderSearch = () => {
    const { publishSource } = this.state;
    const { curTabIndex } = unit_institution;
    // 根据不同的业务信息和当前标签索引，返回对应的搜索组件
    switch (publishSource) {
      case BUSINESS_INFO.SIFA.code:
        return <Search />;
      case BUSINESS_INFO.POCHAN.code:
      case BUSINESS_INFO.ZICHAN.code:
      case BUSINESS_INFO.HAIGUANANDZF.code:
        if (curTabIndex === 1) {
          return <Search />;
        } else if (curTabIndex === 2) {
          return <PromotionSearch />;
        } else if (curTabIndex === 3) {
          // 后期可能支持破产的机构选聘搜索
          // return <MechanismSearch />;
        }
        break;
      default:
        return null;
    }
  };
  render() {
    const {
      vendorId,
      navHeight
    } = this.props
    const {
      shopName,
      logoUrlSquare,
      itemCount,
      tuijieCount,
      chuzhiNoticeCount,
      orgTypeName,
      products,
      isFollowed,
      isLoadingShow,
      isDefaultLogo,
      noticeNum,
      businessTxt,
      publishSource,
      mechanismSelectionNum,
      shopNewestCategory,
      license,
      businessQualificationMaterialListModal,
      businessQualificationMaterialImageListModal,
      idType
    } = this.state
    const isOrg = idType === 2 // 是否是机构
    return (
      <div>
        <Container style={{ paddingTop: `${navHeight+24}px` }}>
          <div className="top-bg"></div>
          {
            this.renderSearch()
          }
          <div className="top-wrap">
            <div className="shop-name-wrap">
              <div className="shop-name">
                {shopName && shopName.length>28?shopName.substring(0,28)+'...':shopName}
                {/* 拍卖行的商家的展示形式 */}
                {
                    license && license.have && license.show && license.link &&
                    license.businessQualificationMaterialList && license.businessQualificationMaterialList.length > 0 && 
                    <span onClick={() => this.handleBusinessQualificationMaterialListModal(true)}>
                      <img
                      className="license-icon"
                      src={license.logo}
                      alt=""
                    />  
                    </span>
                }
                {
                  license.have && license.show && license.link &&
                  !(license.businessQualificationMaterialList && license.businessQualificationMaterialList.length > 0) && 
                  <a 
                    className="license-link"
                    href={license.link}
                    target="_blank"
                  >
                    <img
                      className="license-icon"
                      src={license.logo}
                      alt=""
                    />  
                  </a> 
                }
                {
                  // 如果接口没返回shopId只展示图标无转跳链接
                  license.have && license.show && !license.link &&
                  !(license.businessQualificationMaterialList && license.businessQualificationMaterialList.length > 0) &&
                  <img
                    className="license-icon"
                    src={license.logo}
                    alt=""
                  />  
                }
                { 
                  businessTxt && 
                  <div className="shop-icon">
                    {businessTxt}
                  </div>
                }
              </div>
              
            </div>
            <div className="nums-wrap">
              <div className="nums-main spjs">
                <div className="nums-value">{itemCount || '--'}</div>
                <div className="nums-txt">上拍件数</div>
              </div>
              {(BUSINESS_INFO.ZICHAN.code==publishSource || BUSINESS_INFO.POCHAN.code==publishSource) &&
                <div className="nums-main">
                  <div className="nums-value">{tuijieCount || '--'}</div>
                  <div className="nums-txt">{BUSINESS_INFO.POCHAN.code==publishSource?'投资人招募':'资产推介数'}</div>
                </div>
              }
              {(BUSINESS_INFO.HAIGUANANDZF.code==publishSource || BUSINESS_INFO.SIFA.code==publishSource) &&
                <div className="nums-main">
                  <div className="nums-value">{noticeNum || '--'}</div>
                  <div className="nums-txt">公告数量</div>
                </div>
              }
              {BUSINESS_INFO.HAIGUANANDZF.code === publishSource &&
                  <div className="nums-main">
                    <div className="nums-value">{tuijieCount || '--'}</div>
                    <div className="nums-txt">资产推介数</div>
                  </div>
              }
              {BUSINESS_INFO.POCHAN.code==publishSource &&
                <div className="nums-main jgxps">
                  <div className="nums-value">{mechanismSelectionNum || '--'}</div>
                  <div className="nums-txt">机构选聘</div>
                </div>
              }
              {
                chuzhiNoticeCount > 0 && (
                  <div className="nums-main jgxps">
                    <div className="nums-value">{chuzhiNoticeCount || '--'}</div>
                    <div className="nums-txt">处置公告</div>
                  </div>
                )
              }
            </div>
            <div className="btns-wrap">
              {(isInJd || isInJdjr) &&
                <div 
                  className="btn-wrap btn-wrap-maxwidth red spjs"
                  onClick={() => this.sharePosterClickHandle()}
                >
                  <div className="btn-icon btn-icon-share"></div>
                  <div>分享机构</div>
                </div>
              }
              {
                !isOrg ? (
                  <div 
                    className={`btn-wrap btn-wrap-maxwidth red ${!isInJd?'spjs':''}`}
                    onClick={() => this.followClickHandle()}
                  >
                    <div className={`btn-icon ${isFollowed?'btn-icon-guanzhued':'btn-icon-guanzhu'}`}></div>
                    <div>{isFollowed ? '已关注' : '关注机构'}</div>
                  </div>
                ) : (<div style={{ width: "33.33%" }}></div>)
              }
              {/* {publishSource==BUSINESS_INFO.HAIGUANANDZF.code && <div style={{width:"33.33%"}}></div>} */}
              {
                !(isInJd || isInJdjr) && <div style={{ width: "33.33%" }}></div>
              }
              {(publishSource==BUSINESS_INFO.HAIGUANANDZF.code || publishSource==BUSINESS_INFO.SIFA.code || publishSource==BUSINESS_INFO.POCHAN.code) &&
                <div
                  className="btn-wrap jgxps notice"
                  onClick={()=>{
                    this.gotoNotice()
                  }}
                >
                  <div>查看公告</div>
                  <div className="btn-icon btn-icon-more"></div>
                </div>
              }
            </div>
          </div>
          {
            isLoadingShow ? (
              <Loading />
            ) : ''
          }
          {createPortal(
            <Dialog
              show={businessQualificationMaterialListModal}
              title={'商家资质查询'}
              onCancel={() => this.handleBusinessQualificationMaterialListModal(false)}
              content={<div className="business-qualification-material-modal" style={{ height: '2rem'}}>
                <div className="business-qualification-material-item">
                  <span>营业执照：</span>
                  <div 
                    className="license-link"
                    onClick={() => {
                      this.handleBusinessQualificationMaterialListModal(false)
                      window.open(license.link)
                    }}
                  >查看</div>
                </div>
                <div className="business-qualification-material-item">
                  <span>拍卖经营资质：</span>
                  <div onClick={() => this.handleBusinessQualificationMaterialImageListModal(true)}>查看</div>
                </div>
              </div>}
            />,
            document.querySelector('body'),
          )}
          {createPortal(
            <Dialog
              show={businessQualificationMaterialImageListModal}
              title={'拍卖经营资质'}
              onCancel={() => this.handleBusinessQualificationMaterialImageListModal(false)}
              content={<div className="business-qualification-material-modal">
                <div style={{maxHeight: '5rem'}}>
                {
                  license.businessQualificationMaterialList && license.businessQualificationMaterialList.length > 0  && license.businessQualificationMaterialList.map((item) => 
                  <a target="_blank" rel="noopener noreferrer" href={item}><img
                  className='business-qualification-material-img'
                  src={item}
                  key={item}
                  alt=""
                /></a>  )
                }
                </div>
            </div>}
            />,
            document.querySelector('body'),
          )}
        </Container>
        <SharePoster
          ref={this.sharePoster}
          vendorId={vendorId}
          shopName={shopName}
          logoUrl={logoUrlSquare}
          orgTypeName={orgTypeName}
          products={products}
          isDefaultLogo={isDefaultLogo}
          onComplete={() => this.onSharePosterComplete()}
          shopNewestCategory={shopNewestCategory}
          businessTxt={businessTxt}
        />
      </div>
    );
  }
}

export default TopHeader;
